import { createClient }from "@sanity/client";

export default createClient({
  projectId: "rx2pj1oo",
  dataset: "production",
  useCdn: true,
  apiVersion: "2023-02-01"
  
});